import { render } from "./BankAccount.view.vue?vue&type=template&id=4b654e0a"
import script from "./BankAccount.view.vue?vue&type=script&lang=js"
export * from "./BankAccount.view.vue?vue&type=script&lang=js"

import "./BankAccount.view.vue?vue&type=style&index=0&id=4b654e0a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__